import React from "react";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import { IconButton, Tooltip } from "@material-ui/core";
import { green, red } from "@material-ui/core/colors";

const AdditionalSeatsComp = (props) => {
    const inputDate = {
        marginLeft: "5px",
        backgroundColor: "#26ade4",
        color: "white",
        border: "none",
        outline: "none",
        borderRadius: "5px",
        padding: "10px",
        fontFamily: "Roboto",
        fontSize: "15px",
    };

    const newValueCss = {
        marginLeft: "15px",
        border: "1px dashed #de210b",
        width: "100px",
        fontFamily: "Roboto",
        fontSize: "17px",
        borderRadius: "5px",
        outline: "none",
        height: "fit-content",
    };

    const disable = props.idx > 0;

    return (
        <form
            id={props.el.id}
            idx={props.idx}
            className={props.sign}
            onSubmit={props.add}
        >
            <input type="hidden" value={props.sign} />
            <input type="hidden" idx={props.idx} value={props.idx} />
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "0 10px",
                }}
            >
                <div style={{ margin: "10px" }}>
                    <label htmlFor={props.start_name + props.idx}>
                        Дата начала
                    </label>
                    <input
                        style={inputDate}
                        type="date"
                        id={props.start_name + props.idx}
                        disabled={disable}
                        defaultValue={props.el.start_value}
                    />
                </div>
                <div style={{ margin: "10px" }}>
                    <label htmlFor={props.end_name + props.idx}>
                        Дата окончания
                    </label>
                    <input
                        style={inputDate}
                        type="date"
                        id={props.end_name + props.idx}
                        disabled={disable}
                        defaultValue={props.el.end_value}
                    />
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <label htmlFor={props.price_name + props.idx}>
                    <h4 style={{ margin: "5px" }}>Цена</h4>
                </label>
                <input
                    type="number"
                    id={props.price_name + props.idx}
                    style={newValueCss}
                    disabled={disable}
                    defaultValue={props.el.price_value}
                />
                {!disable ? (
                    <Tooltip title="Добавить условие">
                        <IconButton color="primary" type="submit">
                            <SaveIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip title="Удалить условие">
                        <IconButton
                            onClick={() => props.del(props.el.id)}
                            color="primary"
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </form>
    );
};
export default AdditionalSeatsComp;
